var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmoticonExcited = function SvgEmoticonExcited(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "#4985DF",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0438 0.416626C9.51405 0.416626 0.17749 10.2879 0.17749 22.5C0.17749 34.712 9.51405 44.5833 21.0438 44.5833C32.5735 44.5833 41.9518 34.712 41.9518 22.5C41.9518 10.2879 32.5944 0.416626 21.0438 0.416626ZM21.0646 40.1666C11.8325 40.1666 4.35492 32.2608 4.35492 22.5C4.35492 12.7391 11.8325 4.83329 21.0646 4.83329C30.2968 4.83329 37.7744 12.7391 37.7744 22.5C37.7744 32.2608 30.2968 40.1666 21.0646 40.1666ZM23.1534 17.9508L25.3674 20.2916L27.5814 17.9508L29.7955 20.2916L32.0095 17.9508L27.5814 13.2691L23.1534 17.9508ZM14.5479 17.9508L16.7619 20.2916L18.9759 17.9508L14.5479 13.2691L10.1198 17.9508L12.3338 20.2916L14.5479 17.9508ZM21.0646 34.6458C25.9314 34.6458 30.067 31.4216 31.738 26.9166H10.3913C12.0623 31.4216 16.1979 34.6458 21.0646 34.6458Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoticonExcited, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoticon-excited.93a6d11e.svg";
export { ForwardRef as ReactComponent };